export interface IBaseHeader {
	authorization: string;
	contentType: string;
}

export const getAuthorizationHeader = (accessToken: string): IBaseHeader =>
	({
		authorization: `Bearer ${accessToken}`,
	}) as IBaseHeader;
